
















































































































































































import { isEqual } from 'lodash'
import getVSelectOptionByValue from 'piramis-js-utils/lib/getVSelectOptionByValue'
import { Component, Emit, Mixins, Watch } from 'vue-property-decorator'
import vSelect from 'vue-select'

import DefaultValueWrapper from '../../../DefaultValueWrapper.vue'
import SettingWrapper from "../../../SettingWrapper.vue";
import Tags from '../../../Tags/Tags.vue'
import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput, DefaultValueResetMixin } from '../../mixins'
import { SelectOptionData } from '../../types'
import SelectOption from './components/SelectOption.vue'
import { SelectInputData, SelectInputOptions } from './types'

@Component({
  components: {
    SettingWrapper,
    DefaultValueWrapper,
    FieldWrapper,
    vSelect,
    Tags,
    SelectOption,
  },
})
export default class SelectInput extends Mixins(BaseInput, DefaultValueResetMixin) {
  allOptionsSelected = false

  get areAllOptionsSelected() {
    return !!(this.optionsList && this.optionsList.filter(o => !o.disabled).every(o => Array.isArray(this.value) && this.value.find(v => v.value === o.value)));
  }

  toggleAllSelect() {
    const select = this.$refs['v-select'] as any;

    if (this.allOptionsSelected) {
      this.allOptionsSelected = false
      select.clearSelection();

    } else {
      this.allOptionsSelected = true

      select.options
        .filter((o: SelectOptionData | SelectOption) => 'disabled' in o ? !o.disabled : true)
        .forEach((option: SelectOptionData | SelectOption) => {
          setTimeout(() => {
            select.select(option)
          })
        });
    }
  }

  optionsList: Array<SelectOptionData> | null = null

  loadingOptions = false

  localMultipleClose = null

  @Watch('options')
  onOptionsChange() {
    this.getOptions()
  }

  @Emit('option:selecting')
  optionSelecting(value: any): any {
    return value
  }

  @Emit('input')
  onInput(value: any): any {
    return value
  }

  get isMultipleEmptyArrayDefault() {
    return this.localMultipleClose
  }

  get options(): SelectInputOptions {
    return this.selectInputSettings.options
  }

  get selectInputSettings(): SelectInputData {
    return this.settings as SelectInputData
  }

  get placeholder(): string | undefined {
    return this.selectInputSettings.placeholder
  }

  get multiple(): boolean | undefined {
    return this.selectInputSettings.multiple
  }

  get clearable(): boolean {
    const { clearable } = this.selectInputSettings
    if (clearable !== undefined) {
      return clearable
    }
    return true
  }

  get autocomplete(): boolean {
    return this.optionsList!.length > 5
  }

  get taggable(): boolean | undefined {
    return this.selectInputSettings.taggable
  }

  get clearableValue(): boolean {
    if (this.loadingOptions || this.disabled) {
      return false
    }

    if (this.optionsList!.find((option) => option.value === '' || option.value === null)) {
      return false
    }

    return this.clearable
  }

  isValueEmptyLike(value: any) {
    return value === '' || value === null || value === 0 || value === false
  }

  get hasEmptyLikeValue() {
    return this.optionsList!.find((option) => this.isValueEmptyLike(option.value))
  }

  get value(): SelectOptionData | Array<SelectOptionData> {
    const value = this.modelObject[this.propertyKey]

    if (this.multiple) {
      return this.optionsListFromValues(value)
    }

    if (this.hasEmptyLikeValue) {
      return getVSelectOptionByValue(this.optionsList!, value)
    }

    if (this.selectInputSettings.notFoundOptionText) {
      const returnItem = this.optionsList!.filter(item => item.value === value)[0]

      return returnItem ? returnItem : {
        label: this.isValueEmptyLike(value) ? '-' : this.selectInputSettings.notFoundOptionText,
        value
      }
    } else {
      return value !== undefined ? getVSelectOptionByValue(this.optionsList, value) : null
    }
  }

  set value(value) {
    if (this.multiple) {
      this.setValue(
        (value as Array<SelectOptionData>)
          .filter(o => typeof o?.value !== 'undefined')
          .map((option) => option.value)
      )
    } else {
      if (!this.hasEmptyLikeValue && value === null && this.settingWrapperActiveValue !== undefined) {
        this.setValue(this.settingWrapperActiveValue.value)

      } else {
        this.setValue(value ? (value as SelectOptionData).value : value)
      }
    }

    if (this.settings.settingWrapper !== undefined) {
      this.$nextTick(() => {
        this.isDisabledSettingWrapperActive()
      })
    }
  }

  get hasCreateButtonCallback(): boolean {
    return this.selectInputSettings.createButton !== undefined && typeof this.selectInputSettings.createButton.callback === 'function'
  }

  get createButtonTitle(): string {
    return this.selectInputSettings.createButton && this.selectInputSettings.createButton.title !== undefined
      ? this.selectInputSettings.createButton.title
      : this.$t('select_input_list_empty_button_title').toString()
  }

  optionsListFromValues(model: Array<SelectOptionData> | Array<SelectOption>) {
    const value: Array<SelectOptionData> = []

    for (const selectOptionData of model || []) {
      const res = this.optionsList!.find((option) => option.value === selectOptionData)

      if (res) {
        value.push(res)
      }
    }

    return value
  }

  handleOptionSelected(tag: { label: string }): void {
    this.emptyListButtonCallback(tag)
  }

  emptyListButtonCallback(option?: { label: string }): void {
    if (this.selectInputSettings.createButton) {
      this.selectInputSettings.createButton.callback(option)
    }
  }

  async getOptions(): Promise<any> {
    this.loadingOptions = true

    if (this.options instanceof Promise) {
      this.optionsList = await this.options
    } else if (typeof this.options === 'function') {
      this.optionsList = await this.options()
    } else {
      this.optionsList = this.options
    }

    this.loadingOptions = false
  }

  isDisabledSettingWrapperActive() {
    const value = Array.isArray(this.value) ? this.value : this.value.value

    const disabledValue = this.multiple ? this.disabledOrActiveValue : this.disabledOrActiveValue.value

    this.disabledSettingValueActive = isEqual(disabledValue, value) || ((this.$slots['value-stub'] ?? false) && isEqual(this.disabledOrActiveValue, value))
  }

  async mounted(): Promise<void> {
    try {
      await this.getOptions()

      if (this.multiple) {
        this.allOptionsSelected = this.areAllOptionsSelected
      }

      if (this.settings.settingWrapper !== undefined) {
        this.isDisabledSettingWrapperActive()
      }
    } catch (error) {
      console.error(error)
    }
  }
}
